module.exports = __webpack_public_path__ + "static/media/SelfAwarenessOfValues.5dcd20c0.png";